import React from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '../Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  vimeoId?: string;
  title?: string;
}

export const ProfileVideoModal = ({
  isOpen,
  onClose,
  vimeoId,
  title,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('components.modals.profileVideo.defaultTitle');
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={resolvedTitle}
      className='w-full max-w-3xl'
    >
      {vimeoId ? (
        <div className='relative pb-[56.25%] h-0'>
          <iframe
            title={resolvedTitle}
            src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1`}
            allow='autoplay; fullscreen'
            allowFullScreen
            className='absolute top-0 left-0 w-full h-full'
            frameBorder='0'
          />
        </div>
      ) : (
        <p>{t('components.modals.profileVideo.noVideo')}</p>
      )}
    </Modal>
  );
};
